import {DocumentAmendment} from "common/flowmaster/types/amendment";

// The raw amendments an issue's LLM response carries can arrive in one of two
// shapes (a bare array, or nested under `.amendments`). This normalises both
// into a flat `DocumentAmendment[]`.
// TODO - simplify when dealing with a single amendments shape returned from LLM
export interface IssueWithAmendments {
  llm_response?: {
    amendments?: {
      value?: {
        amendments?: DocumentAmendment[] | {amendments?: DocumentAmendment[]};
      };
    };
  };
}

export default function getIssueAmendments(
  issue: IssueWithAmendments,
): DocumentAmendment[] {
  const slot = issue.llm_response?.amendments?.value?.amendments;
  if (Array.isArray(slot)) {
    return slot;
  }
  if (Array.isArray(slot?.amendments)) {
    return slot.amendments;
  }
  return [];
}
